/**
 * Declares application pages and applies navigation tracking and role
 * authorization consistently to every registered route.
 */
import {
    HomePage,
    ProfilePage,
    ApiSettings,
    AttachmentSettings,
    LogsPage,
    MsAccessSettings,
    UserAdminSettings,
    EmailSettingsPage,
    NetworkLocationSettings,
    ArchivedEmailsPage
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import ProtectedRoute from './ProtectedRoute';
import appRoles from './auth/roles-info';

const routes = [
    {
        path: '/home',
        element: HomePage,
        permission: appRoles.anonymous.name
    },
    {
        path: '/logs',
        element: LogsPage,
        permission: appRoles.bulkEmailAdmin.name
    },
    {
        path: '/api-settings',
        element: ApiSettings,
        permission: appRoles.admin.name
    },
    {
        path: '/attachment-settings',
        element: AttachmentSettings,
        permission: appRoles.admin.name
    },
    {
        path: '/user-admin-settings',
        element: UserAdminSettings,
        permission: appRoles.admin.name
    },
    {
        path: '/network-location-settings',
        element: NetworkLocationSettings,
        permission: appRoles.admin.name
    },
    {
        path: '/archived-emails',
        element: ArchivedEmailsPage,
        permission: appRoles.bulkEmailAdmin.name
    },
    {
        path: '/bulk-email-settings',
        element: EmailSettingsPage,
        permission: appRoles.bulkEmailAdmin.name
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(
            () => (
                <ProtectedRoute 
                    element={route.element} 
                    requiredPermission={route.permission}
                />
            ),
            route.path
        )
    };
});
